import { apiService } from '@/utils/api'

export interface DeviceCollectionTask {
  id: number
  device_id: string
  enabled: boolean
  next_collect_at: string
  last_collect_start?: string
  last_collect_end?: string
  last_collect_ok_at?: string
  last_collect_failed?: string
  last_error?: string
  created_at: string
  updated_at: string
}

export interface CreateDeviceCollectionTaskPayload {
  device_id: string
  enabled?: boolean
  next_collect_at?: string
}

export interface UpdateDeviceCollectionTaskPayload {
  enabled?: boolean
  next_collect_at?: string
}

export interface RunNowResult {
  started: boolean
}

export async function createDeviceCollectionTask(
  payload: CreateDeviceCollectionTaskPayload
): Promise<DeviceCollectionTask> {
  return apiService.post<DeviceCollectionTask>('/api/v1/collection-tasks', payload)
}

export async function listDeviceCollectionTasks(): Promise<DeviceCollectionTask[]> {
  return apiService.get<DeviceCollectionTask[]>('/api/v1/collection-tasks')
}

export async function updateDeviceCollectionTask(
  deviceID: string,
  payload: UpdateDeviceCollectionTaskPayload
): Promise<DeviceCollectionTask> {
  return apiService.put<DeviceCollectionTask>(`/api/v1/collection-tasks/${encodeURIComponent(deviceID)}`, payload)
}

export async function deleteDeviceCollectionTask(deviceID: string): Promise<{ deleted: boolean }> {
  return apiService.delete<{ deleted: boolean }>(`/api/v1/collection-tasks/${encodeURIComponent(deviceID)}`)
}

export async function runDeviceCollectionTaskNow(deviceID: string): Promise<RunNowResult> {
  return apiService.post<RunNowResult>(`/api/v1/collection-tasks/${encodeURIComponent(deviceID)}/run-now`, {})
}
